import KeyboardDoubleArrowLeft from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRight from '@mui/icons-material/KeyboardDoubleArrowRight';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useSidebarState } from 'react-admin';
import { MenuItemProps } from 'shared/mui/MenuItem/MenuItem';
import { Tooltip } from 'shared/mui/Tooltip';

import { StyledMenuItem } from './MenuToggleButton.styled';

export const MenuToggleButton: React.FC<MenuItemProps> = (props) => {
  const [openSidebar] = useSidebarState();
  const translate = useTypedTranslate();

  return (
    <>
      {openSidebar ? (
        <StyledMenuItem {...props}>
          <KeyboardDoubleArrowLeft sx={{ marginRight: '32px', color: 'rgba(0, 0, 0, 0.6)' }} />
          {translate('app.buttons.collapse')}
        </StyledMenuItem>
      ) : (
        <Tooltip placement="right" title="Развернуть">
          <StyledMenuItem {...props}>
            <KeyboardDoubleArrowRight sx={{ color: 'rgba(0, 0, 0, 0.6)' }} />
          </StyledMenuItem>
        </Tooltip>
      )}
    </>
  );
};
